<template>
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <!-- Header -->
    <Header
      title="Open new card"
      :showGoBack="true"
    />

    <!-- Main content -->
    <main
      class="scrollable"
      :style="{paddingTop: '10px', paddingBottom: '20px'}"
    >
      <!-- types -->
      <section
        :style="{marginBottom: '30px'}"
        class="container"
      >
        <span
          class="t14"
          :style="{
            display: 'block',
            marginBottom: '14px',
          }"
          >Type</span
        >
        <ul
          class="row-center"
          :style="{gap: '11px'}"
        >
          <li
            v-for="cardTypes in cardTypes"
            :key="cardTypes"
            @click="selectedCardType = cardTypes"
            class="center"
            :style="{
              width: '100%',
              height: '30px',
              borderRadius: '6px',
              border: '1px solid var(--main-dark)',
              backgroundColor:
                cardTypes === selectedCardType
                  ? 'var(--main-dark)'
                  : 'var(--white-color)',
            }"
          >
            <span
              class="t14"
              :style="{
                color:
                  cardTypes === selectedCardType
                    ? 'var(--white-color)'
                    : 'var(--main-dark)',
              }"
            >
              {{ cardTypes }}
            </span>
          </li>
        </ul>
      </section>

      <!-- Currencies -->
      <section
        :style="{marginBottom: '30px'}"
        class="container"
      >
        <span
          class="t14"
          :style="{
            display: 'block',
            marginBottom: '14px',
          }"
          >Choose currency</span
        >
        <ul
          class="row-center"
          :style="{gap: '11px'}"
        >
          <li
            v-for="currency in currencies"
            :key="currency"
            @click="selectedCurrency = currency"
            class="center"
            :style="{
              width: '100%',
              height: '30px',
              borderRadius: '6px',
              border: '1px solid var(--main-dark)',
              backgroundColor:
                currency === selectedCurrency
                  ? 'var(--main-dark)'
                  : 'var(--white-color)',
            }"
          >
            <span
              class="t14"
              :style="{
                color:
                  currency === selectedCurrency
                    ? 'var(--white-color)'
                    : 'var(--main-dark)',
              }"
            >
              {{ currency }}
            </span>
          </li>
        </ul>
      </section>

      <!-- Payment systems -->
      <section
        :style="{marginBottom: '30px'}"
        class="container"
      >
        <span
          class="t14"
          :style="{
            display: 'block',
            marginBottom: '14px',
          }"
          >Payment system</span
        >
        <ul
          class="row-center"
          :style="{gap: '11px'}"
        >
          <li
            v-for="paymentSystem in paymentSystems"
            :key="paymentSystem"
            @click="selectedPaymentSystem = paymentSystem"
            class="center"
            :style="{
              width: '100%',
              height: '30px',
              borderRadius: '6px',
              border: '1px solid var(--main-dark)',
              backgroundColor:
                paymentSystem === selectedPaymentSystem
                  ? 'var(--main-dark)'
                  : 'var(--white-color)',
            }"
          >
            <span
              class="t14"
              :style="{
                color:
                  paymentSystem === selectedPaymentSystem
                    ? 'var(--white-color)'
                    : 'var(--main-dark)',
              }"
            >
              {{ paymentSystem }}
            </span>
          </li>
        </ul>
      </section>

      <!-- Cards -->
      <section :style="{marginBottom: '16px'}">
        <swiper-container
          class="swiper"
          space-between="16"
          slides-per-view="auto"
        >
          <swiper-slide
            v-for="(e, index) in cards"
            :key="e.id"
            class="swiper-slide"
            :style="{
              marginLeft: index === 0 ? '20px' : '0px',
            }"
          >
            <img
              alt="card"
              :src="e.image"
              :class="'clickable'"
              @click="$router.push(e.route)"
              :style="{width: '280px', display: 'block', borderRadius: '14px'}"
            />
          </swiper-slide>
        </swiper-container>
      </section>

      <!-- Description -->
      <section :class="'container'">
        <p :class="'t16'">
          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
          dolore eu fugiat nulla pariatur.
        </p>
      </section>
    </main>

    <footer :style="{padding: '20px'}">
      <Button
        title="Add new card"
        :onClick="() => $router.push(routes.TAB_NAVIGATOR)"
      />
    </footer>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import 'swiper/css';
import 'vue3-carousel/dist/carousel.css';

import {useOpacity} from '@/hooks';
import {Button} from '@/components';
import {Header} from '@/components';
import {Swiper, SwiperSlide} from 'swiper/vue';

const currencies = ['USD', 'EUR'];
const cardTypes = ['Debet', 'Credit'];
const paymentSystems = ['VISA', 'MASTERCARD'];

import {routes} from '@/routes';

const selectedCurrency = ref(currencies[0]);
const selectedCardType = ref(cardTypes[0]);
const selectedPaymentSystem = ref(paymentSystems[0]);

const opacity = useOpacity();

const cards = [
  {
    id: 1,
    image: require('@/assets/cards/03.png'),
    route: routes.CARD_DETAILS,
  },
  {
    id: 2,
    image: require('@/assets/cards/04.png'),
    route: routes.CARD_DETAILS,
  },
];
</script>

<style scoped>
.swiper-slide {
  width: auto !important;
}
</style>
